<template>
	<el-dialog v-model="showDialog" width="940px" :before-close="BeforeClose" destroy-on-close :show-close="false"
		custom-class="dialog_transparent_content">
		<div class="login-container">
			<img class="loginImg" src="../../public/imgs/login.png" />

			<div class="login_close" @click="BeforeClose">
				&times;
			</div>
			<div class="logo">
				<img class="logoImg" :src="logoUrl" />
				<span v-if="orgExtModel.TypeTag">
					<div class="type_name">{{orgExtModel.TypeName}}</div>
					<div class="type_tag">{{orgExtModel.TypeTag}}</div>
				</span>
				<span v-else>{{orgExtModel.TypeName}}</span>
			</div>

			<div class="login-page">
				<el-tabs v-model="active">
					<el-tab-pane label="密码登录" name="first">
						<el-form :model="ruleForm2" :rules="rules2" status-icon ref="ruleForm2" label-position="left"
							label-width="0px" class="demo-ruleForm ">
							<el-form-item prop="CardCode">
								<div>
									<el-input @keyup.enter.native="shiftFocus" type="Content"
										v-model="ruleForm2.CardCode" auto-complete="off" placeholder="帐号/手机号"
										style="width: 340px;"></el-input>
								</div>
							</el-form-item>
							<el-form-item prop="password">
								<div>
									<el-input @keyup.enter.native="handleSubmit" ref="PWD" type="password"
										v-model="ruleForm2.password" auto-complete="off" placeholder="密码"
										style="width: 340px;"></el-input>
									<div style="text-align: right;">
										<span @click="forgotpwd()"><el-link
												style="cursor: pointer; ">忘记密码</el-link></span>
									</div>
								</div>
							</el-form-item>
							<el-form-item style="width: 100%">
								<el-button type="primary" style="width: 100%" @click="toLogin" :loading="logining">登录
								</el-button>
							</el-form-item>
							<el-form-item class="gobuybox" v-if="orgExtModel.IsCanLineSell==1">
								<span style="float: right; display:inline-block;"> <el-link style="color:#409eff"
										@click="gotobuy()">去开通账号</el-link> </span>
							</el-form-item>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="短信登录" v-if="orgExtModel.OrgID!='137'">
						<el-form :model="ruleForm2" :rules="rules3" status-icon ref="ruleForm2" label-position="left"
							label-width="0px" class="demo-ruleForm ">
							<el-form-item prop="Mobile">
								<div>
									<el-input @keyup.enter.native="shiftFocus" type="Content" v-model="ruleForm2.Mobile"
										auto-complete="off" placeholder="手机号" style="width: 340px;"></el-input>
								</div>
							</el-form-item>
							<el-form-item prop="password">
								<div>
									<el-input @keyup.enter.native="handleSubmit" ref="PWD" v-model="ruleForm2.Code"
										auto-complete="off" placeholder="验证码" style="width: 340px;">
										<template #suffix>
											<el-button type="primary" :disabled="CodeMsg!='获取'" size="small"
												@click="ClickCode()">{{CodeMsg}}</el-button>
										</template>
									</el-input>
									<div style="height:34px;">

									</div>
								</div>
							</el-form-item>
							<el-form-item style="width: 100%">
								<el-button type="primary" style="width: 100%" @click="loginbycode"
									:loading="logining">登录
								</el-button>
							</el-form-item>
							<el-form-item class="gobuybox" v-if="orgExtModel.IsCanLineSell==1">
								<span style="float: right; display:inline-block;"> <el-link style="color:#409eff"
										@click="gotobuy()">去开通账号</el-link> </span>
							</el-form-item>
						</el-form>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
	</el-dialog>
	<loginVerify :isShowVerify="isShowVerify" @onSuccess="onVerifySuccess" @onClose="onClose"></loginVerify>

	<el-dialog v-model="isShowSetArea" title="卡号绑定省份" destroy-on-close width="700px">
		<setArea :cardId="cardInfo.ID" @onSetAreaClose="onSetAreaClose" @onSetAreaFinished="onSetAreaFinished">
		</setArea>
	</el-dialog>

	<el-dialog v-model="showGiftTip" title="福利提醒" destroy-on-close width="600px" @close="NotGetGift" class="diaGift">
		<giftTip @onGetGift="GetGift" @onNotGetGift="NotGetGift">
		</giftTip>
	</el-dialog>
	<ForgotPwd ref="forgotpassword" fromurl="cplogin"></ForgotPwd>

	<el-dialog v-model="showCards" title="请选择一个卡号进行登录" destroy-on-close width="450px">
		<el-row :gutter="10">
			<el-col :span="12" v-for="(item,n) in CardList">
				<div class="card_items" @click="LoginByCardCode(item)">
					{{item.CardCode+(item.Name?'&nbsp;&nbsp;&nbsp;'+item.Name+'':'')}}
				</div>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
	import loginVerify from './cp_loginVerify.vue'
	import setArea from './cp_cardSetArea.vue';
	import giftTip from './cp_gifttip.vue';
	import ForgotPwd from './cp_forgotpwd.vue';

	export default {
		components: {
			loginVerify,
			setArea,
			giftTip,
			ForgotPwd
		},
		props: ['type', 'fatherMethod', 'loginShow'],
		watch: {
			loginShow() {
				let _this_ = this;
				
				_this_.orgExtModel = _this_.$store.getters.getOrgExtModel();
				
				this.logoUrl = this.$store.getters.getLogoUrl()
				
				this.showDialog = this.loginShow;
			},
		},
		data() {
			return {
				CodeMsg: '获取',
				active: 'first',
				showDialog: false,
				logoUrl: '',
				isUpCard: this.$store.getters.getIsUpCard(),
				OrgID: this.$store.getters.getOrgID(),
				rootOrgList: [],
				orgThow: false,
				logining: false,
				vefPwd: false,
				ruleForm2: {
					CardCode: "",
					password: ""
				},
				rules2: {
					CardCode: [{
							required: true,
							message: "请输入账号",
							trigger: "blur"
						},
						{
							validator: this.verificationUid,
							trigger: "blur"
						},
					],
					password: [{
							required: true,
							message: "请输入密码",
							trigger: "blur"
						},
						{
							validator: this.verificationPwd,
							trigger: "blur"
						},
					]
				},
				rules3: {
					Mobile: [{
						required: true,
						message: "请输入手机号",
						trigger: "blur"
					}, ],
					Code: [{
						required: true,
						message: "请输入激活码",
						trigger: "blur"
					}, ]
				},
				checked: false,
				isShowVerify: false,
				cardInfo: {},
				isShowSetArea: false,
				orgExtModel: {},
				showGiftTip: false,
				instever: 0,
				CardList: [],
				showCards: false,
			};
		},
		methods: {
			LoginByCardCode(item){
				this.$http.get("/Student/LoginByCardCode", {
					CardCode: item.CardCode,
				}, true).then((res) => {
					if (res.code == 2) { //首次登录,未设置省份
						this.cardInfo = res.data;
						this.isShowSetArea = true;
						return;
					}
					
					if (res.code == 1) { //非首次登录，已设置省份
						this.$message.success("登录成功");
						this.showCards = false;
						this.userInfo = res.data.UserInfo;
						this.token = res.data.Token;
						this.$store.commit("setUserInfo", res.data.UserInfo);
						this.$store.commit("set_token", res.data.Token);
						this.$store.commit("set_XuanKeType", res.data.XuanKeType);
						this.$store.commit("set_GKModel", res.data.Model);
				
						this.$store.commit("set_StuTags", res.data.Tags);
				
						this.$store.commit("set_isVirtualLogin", false);
				
						//弹窗登录
						//登录后，检查是否有福利领取
						if (this.userInfo.WLType != '' || this.userInfo.Sbj != '') {
							//非首次登录，已设置基本信息
							this.GiveStuGift();
						} else {
							//首次登录，未设置基本信息
							this.loginAfter();
						}
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			loginbycode() {
				this.$http.get("/Student/LoginByMobileCode", {
					Mobile: this.ruleForm2.Mobile,
					Code: this.ruleForm2.Code
				}, true).then((res) => {
					if (res.code == 3) {
						this.showCards = true;
						this.CardList = res.data;
						return;
					}
					if (res.code == 2) { //首次登录,未设置省份
						this.cardInfo = res.data;
						this.isShowSetArea = true;
						return;
					}
					if (res.code == 1) { //非首次登录，已设置省份
						this.$message.success("登录成功");
						if (this.checked) { //如果选中了记住密码的选项
							this.setCookie(this.ruleForm2.CardCode, this.ruleForm2.password, "1",
								7); //则去设置cookie,username是要提交的用户名，password是密码，7是要存储的天数
						} else {
							this.clearCookie() //如果没有选中记住密码，那就清除cookie
						}
						this.userInfo = res.data.UserInfo;
						this.token = res.data.Token;
						this.$store.commit("setUserInfo", res.data.UserInfo);
						this.$store.commit("set_token", res.data.Token);
						this.$store.commit("set_XuanKeType", res.data.XuanKeType);
						this.$store.commit("set_GKModel", res.data.Model);

						this.$store.commit("set_StuTags", res.data.Tags);

						this.$store.commit("set_isVirtualLogin", false);

						//弹窗登录
						//登录后，检查是否有福利领取
						if (this.userInfo.WLType != '' || this.userInfo.Sbj != '') {
							//非首次登录，已设置基本信息
							this.GiveStuGift();
						} else {
							//首次登录，未设置基本信息
							this.loginAfter();
						}
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			StartCode() {
				if (this.instever) {
					clearInterval(this.instever)
				}
				let second = 60;
				let _this_ = this;
				this.instever = setInterval(function() {
					_this_.CodeMsg = second + '秒';
					second--;
					if (second <= 0) {
						clearInterval(_this_.instever)
						_this_.CodeMsg = "获取"
					}
				}, 1000)
			},
			ClickCode() {
				let Mobile = this.ruleForm2.Mobile;
				if (!Mobile) {
					this.$message.error("请先输入手机号");
					return;
				}
				this.$http.get("Student/SendCheckCode", {
					Mobile
				}, true).then((res) => {
					if (res.code == 1) {
						this.$message.success("验证码已发送，注意查收");

						this.StartCode();
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			onSetAreaFinished() {
				this.onSetAreaClose();
				this.login();
			},
			onSetAreaClose() {
				this.isShowSetArea = false;
			},
			onClose() {
				this.isShowVerify = false;
			},
			onVerifySuccess() {
				this.login();
				this.isShowVerify = false;
			},
			AddLoginCount() {
				let count = this.$store.getters.get_loginCount();
				count++;
				this.$store.commit("set_loginCount", count);
			},
			toLogin() {
				let count = this.$store.getters.get_loginCount()
				if (count > 1) {
					this.isShowVerify = true;
				} else {
					this.isShowVerify = false;
					this.login();
				}
			},
			BeforeClose() {
				this.$emit("BeforeClose")
			},
			login() {
				this.$http.get("/Student/LoginByPwd", {
					CardCode: this.ruleForm2.CardCode,
					Pwd: this.ruleForm2.password,
							IsMobile:0,
				}, true).then((res) => {
					if (res.code == 2) { //首次登录,未设置省份
						this.cardInfo = res.data;
						this.isShowSetArea = true;
						return;
					}
					if (res.code == 1) { //非首次登录，已设置省份
						this.$message.success("登录成功");
						if (this.checked) { //如果选中了记住密码的选项
							this.setCookie(this.ruleForm2.CardCode, this.ruleForm2.password, "1",
								7); //则去设置cookie,username是要提交的用户名，password是密码，7是要存储的天数
						} else {
							this.clearCookie() //如果没有选中记住密码，那就清除cookie
						}
						this.userInfo = res.data.UserInfo;
						this.token = res.data.Token;
						this.$store.commit("setUserInfo", res.data.UserInfo);
						this.$store.commit("set_token", res.data.Token);
						this.$store.commit("set_XuanKeType", res.data.XuanKeType);
						this.$store.commit("set_GKModel", res.data.Model);

						this.$store.commit("set_StuTags", res.data.Tags);

						this.$store.commit("set_isVirtualLogin", false);

						//弹窗登录
						//登录后，检查是否有福利领取
						if (this.userInfo.WLType != '' || this.userInfo.Sbj != '') {
							//非首次登录，已设置基本信息
							this.GiveStuGift();
						} else {
							//首次登录，未设置基本信息
							this.loginAfter();
						}
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			loginAfter() {
				if (this.type != 2) {
					this.redirect();
					this.$router.go(0);
					return;
				} else {
					//从专业和院校来
					if (this.fatherMethod) {
						this.fatherMethod();
						this.$router.go(0);
						return;
					}
				}

				let obj = {};
				obj.AreaID = this.userInfo.AreaID;
				obj.AreaName = this.userInfo.AreaName;
				this.$store.commit("set_UserSetArea", obj);
				this.$router.go(0);
			},
			handleSubmit() {
				this.vefPwd = true;
				this.$refs["ruleForm2"].validate((valid) => {
					if (valid) {
						this.login();
						this.logining = false;
					} else {
						console.log("error submit!");
						return false;
					}
				});
			},
			setCookie(c_name, c_pwd, c_cheack, exdays) {
				var exdate = new Date(); //获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
				//字符串拼接cookie
				window.document.cookie =
					"CardCode" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();

				//expires是设置cookie的过期时间，toGMTString是将日期转为GMT的字符串进行拼接
				window.document.cookie =
					"password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();

				window.document.cookie =
					"ischecked" + "=" + c_cheack + ";path=/;expires=" + exdate.toGMTString();

			},
			//读取cookie  将用户名和密码回显到input框中
			getCookie() {
				if (document.cookie.length > 0) {
					var arr = document.cookie.split("; "); //这里显示的格式需要切割一下
					for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split("="); //再次切割
						//判断查找相对应的值
						if (arr2[0] == "CardCode") {
							this.ruleForm2.CardCode = arr2[1]; //保存到保存数据的地方（data中）
						} else if (arr2[0] == "password") {
							this.ruleForm2.password = arr2[1];
						} else if (arr2[0] == "ischecked") {
							if (arr2[1] == "1") {
								this.checked = true;
							} else {
								this.checked = false;
							}
						}
					}
				}
			},
			//清除cookie
			clearCookie: function() {
				this.setCookie("", "", "", -1);
			},
			shiftFocus() {
				this.$refs.PWD.focus();
			},
			redirect() {
				// this.$router.push({
				// 	path: this.$store.getters.getLoginToPath()
				// });
			},
			gotobuy() {
				let byurl = "/productlist";
				let lianxi = '/orgServer';
				debugger
				if (this.orgExtModel.OnlineSellType == '联系方式') {
					this.$router.push({
						path: lianxi
					});
				} else {
					this.$router.push({
						path: byurl
					});
				}

				// this.$http.get("Base/GetIsJumpToQrCode", {

				// }, true).then(res => {
				// 	if (res.code == 1) {
				// 		if (res.data) {
				// 			this.$router.push({
				// 				path: lianxi
				// 			});
				// 		} else {
				// 			this.$router.push({
				// 				path: byurl
				// 			});
				// 		}
				// 	}
				// });

				// this.$router.push({ path: '/productlist'})
			},
			//赠送福利
			GiveStuGift() {
				this.$http.get("Gift/GiveStuGift", {
					triggerType: 1,
				}, true).then((res) => {
					if (res.code == 1) {
						let resData = res.data;
						if (resData > 0) {
							this.showGiftTip = true;
						} else {
							this.loginAfter();
						}
					} else {
						this.loginAfter();
					}
				});
			},
			//领取福利
			GetGift() {
				this.showGiftTip = false;
				location.href = location.origin + '/#/myGift';
				location.reload();
			},
			//暂不领取
			NotGetGift() {
				this.showGiftTip = false;
				this.loginAfter();
			},
			// //点击忘记密码链接
			forgotpwd() {
				this.BeforeClose(); //关闭登录窗口
				this.$refs.forgotpassword.forgotpwd();
			},
		},
		created() {
			this.getCookie();

			let isUpCard = this.isUpCard == 1 && this.OrgID != '057' && this.OrgID != '062' && this.OrgID != '063'
			
		}
	};
</script>
<style>
	.dialog_transparent_content {
		background-color: transparent;
		box-shadow: 0 0 0;
	}

	.diaGift {
		background-image: url('/imgs/gifttipbackground.png');
		background-size: cover;
		/* 这将确保背景图覆盖整个对话框 */
		background-repeat: no-repeat;
		/* 防止背景图重复 */
		--el-dialog-bg-color: unset !important;
		--el-dialog-box-shadow: unset !important;
	}

	.diaGift .el-dialog__header {
		display: none;
	}
</style>
<style scoped="scope" lang="less">
	.card_items {
		border: 1px solid #ddd;
		padding: 10px;
		margin-bottom: 10px;
		border-radius: 8px;
		cursor: pointer;
	}
	.card_items:hover{
		background-color: #f4f4f4;
	}

	.type_name {
		font-size: 26px;
	}

	.type_tag {
		font-size: 16px;
	}

	.login-container {
		position: relative;
		width: 100%;
		height: 460px;
	}

	.login_close {
		font-size: 20px;
		position: absolute;
		margin-right: 20px;
		z-index: 9999;
		margin-top: 20px;
		display: inline-block;
		width: 30px;
		height: 30px;
		right: 0;
		cursor: pointer;
		color: #888;
	}

	.login_close:hover {
		opacity: 0.8;
	}

	.logo {
		position: absolute;
		width: 513px;
		top: 67px;
		right: 10px;
		text-align: center;

		span {
			font-size: 30px;
			display: inline-block;
			vertical-align: middle;
			color: #303133;
		}
	}

	.logoImg {
		height: 57px;
		margin-right: 10px;
		width: auto;
		display: inline-block;
		vertical-align: middle;
	}

	.loginImg {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: auto;
	}

	.login-page {
		border-radius: 5px;
		position: absolute;
		top: 160px;
		right: 50px;
		width: 340px;
		padding: 35px 35px 15px;
		background: #fff;
		border: 1px solid #eaeaea;
		box-shadow: 0 0 25px #cac6c6;
	}

	label.el-checkbox.rememberme {
		margin: 0px 0px 15px;
		text-align: left;
	}

	.sxt-org-select {
		width: 200px;
		height: 40px;
		background-color: #409EFF;
		color: #fff;
		margin-right: 10px;
		border: 0px;
	}

	.gobuybox {
		float: right;
	}
</style>